"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AerospaceMission = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("../prelude/PreludeCard");
var CardName_1 = require("../../CardName");
var BuildColony_1 = require("../../deferredActions/BuildColony");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var AerospaceMission = (function (_super) {
    __extends(AerospaceMission, _super);
    function AerospaceMission() {
        return _super.call(this, {
            name: CardName_1.CardName.AEROSPACE_MISSION,
            tags: [Tags_1.Tags.SPACE],
            metadata: {
                cardNumber: 'Y01',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.colonies(1).nbsp.colonies(1).br;
                    b.minus().megacredits(14);
                }),
                description: 'Place 2 colonies. Pay 14 M€.',
            },
        }) || this;
    }
    AerospaceMission.prototype.canPlay = function (player) {
        return player.canAfford(14);
    };
    AerospaceMission.prototype.play = function (player) {
        player.deductResource(Resources_1.Resources.MEGACREDITS, 14);
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select where to build the first colony'));
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select where to build the second colony'));
        return undefined;
    };
    return AerospaceMission;
}(PreludeCard_1.PreludeCard));
exports.AerospaceMission = AerospaceMission;
//# sourceMappingURL=AerospaceMission.js.map